import * as React from 'react';
const ZampeDiGallinaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M73.47 99.99c6.32-14.46 20.58-23.79 36.32-23.79 15.75 0 30 9.34 36.32 23.79-6.32 14.46-20.57 23.8-36.32 23.8-15.74 0-30-9.33-36.32-23.8"
      className="prefix__cls-2"
    />
    <circle cx={109.78} cy={100} r={18.79} className="prefix__cls-2" />
    <path
      d="M121.06 100c0 6.24-5.03 11.27-11.27 11.27S98.52 106.24 98.52 100c0-.8.07-1.58.25-2.33 1 .68 2.21 1.08 3.51 1.08 3.46 0 6.26-2.81 6.26-6.26 0-1.3-.4-2.5-1.08-3.51.75-.18 1.53-.25 2.33-.25 6.24 0 11.27 5.03 11.27 11.27M46.38 110.24l10.16-1.86 12.38 1.86M63.08 103.64l-6.54 4.74M49.46 89.25l13.62 2.02"
      className="prefix__cls-1"
    />
  </svg>
);
export default ZampeDiGallinaIcon;
